import {createBrowserRouter} from "react-router-dom";

// Dashboard
import Layout from "../layout/Layout";
import Home from "../Page/Home/Home";

// Auth
import NotFound from "../Auth/NotFound";
import Login from "../Auth/Login";
import Error from "../Auth/Error";
import Register from "../Auth/Register";
import NewPassword from "../Auth/NewPassword";
import LockScreen from "../Auth/LockScreen";
import Verification from "../Auth/Verification";
import {routes} from "./route";
import Order from "../Page/Order/Order";
import UpdateOrder from "../Page/Order/UpdateOrder/UpdateOrder";


export const router = createBrowserRouter([
    {
        path: routes.home,
        element: <Layout/>,
        errorElement: <NotFound/>,
        children: [
            {
                index: true,
                element: <Home/>,
            },
            // {
            //     path: routes.orders,
            //     element: <Order/>
            // },

            {
                path:routes.orders,
                children:[
                    {
                        // path: routes.reports,
                        index: true,
                        element: <Order/>
                    },
                    {
                        path: routes.update_order,
                        element:<UpdateOrder/>
                    }
                ]
            },
        ],
    },
    {
        path: "/auth",
        children: [
            {
                path: routes.login,
                element: <Login/>,
            },
            {
                path: "register",
                element: <Register/>,
            },
            {
                path: "new-password",
                element: <NewPassword/>,
            },
            {
                path: "error",
                element: <Error/>,
            },
            {
                path: "lock-screen",
                element: <LockScreen/>,
            },
            {
                path: "verification",
                element: <Verification/>,
            },
        ],
    },
]);

